import { render, staticRenderFns } from "./VlIndexDossierCard.vue?vue&type=template&id=37a378d7&"
import script from "./VlIndexDossierCard.vue?vue&type=script&lang=js&"
export * from "./VlIndexDossierCard.vue?vue&type=script&lang=js&"
import style0 from "./VlIndexDossierCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports